var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',_vm._l((12),function(ind){return _c('v-col',{key:ind,attrs:{"cols":"12","sm":"12","md":"4","lg":"3"}},[_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"max-width":"300","type":"card"}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }